import { fetchHistoryPaymentPosition2 } from '@/api/business/bankstatement'
import { useQuery } from '@tanstack/react-query'

export const BankStatementHistoryPaymentPosition2Keys = {
    all: ['bankstatementhistorypaymentposition2'] as const,
    lists: () => [...BankStatementHistoryPaymentPosition2Keys.all, 'list'] as const,
    list: (page: number, perPage: number, filters: any) =>
        [...BankStatementHistoryPaymentPosition2Keys.lists(), page, perPage, filters] as const,
    details: () => [...BankStatementHistoryPaymentPosition2Keys.all, 'detail'] as const,
    detail: (params: string) => [...BankStatementHistoryPaymentPosition2Keys.details(), params] as const,
}

export const useBankStatmentHistoryPaymentPosition2Query = ({X_CHAVE, X_TYPE, SK_TEMPO_INICIO, SK_TEMPO_FIM, enableStatus}) => {
    return useQuery({
        enabled: enableStatus,
        queryFn : () => fetchHistoryPaymentPosition2({X_CHAVE, X_TYPE, SK_TEMPO_INICIO, SK_TEMPO_FIM}),
        queryKey: BankStatementHistoryPaymentPosition2Keys.lists(),
    })
}
